<div class="sag-debugger">
  <div class="sag-actions">
    <button mat-raised-button color="primary" (click)="clearSagState()">Clear SAG State</button>
    <button mat-raised-button color="primary" (click)="enableSpecialAccessGroup()">Make Cluster SAG</button>
    <button mat-raised-button color="primary" (click)="disableSpecialAccessGroup()">Make Cluster Public</button>
    <mat-slide-toggle (change)="onChangeSagPlayerStats($event)">SAG player stats</mat-slide-toggle>
  </div>
  <div class="current-sag-state">
    @for (sag of sagStates; track $index) {
      <div class="sag-cluster-info">
        <span> ClusterId: {{ sag.clusterId }} </span>
        <span class="ml-4">
          Queue:
          @for (queue of sag.queue; track $index) {
            <span class="user-info"> {{ queue.userId }} - {{ queue.firstName ?? '' }} {{ queue.lastName ?? '' }} </span>
          }
        </span>
        <button class="delete-cluster-pos" mat-raised-button color="warn" (click)="removeQueueFromState(sag.clusterId)">
          remove
        </button>
      </div>
    }
  </div>
</div>
